<template>
  <div style="padding: 30px 0">
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>面试信息</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <template v-if="source">
      <div :key="index" v-for="(item, index) in source.interviews">
        <a-row type="flex" justify="space-between">
          <a-col span="12" style="padding-left:20px">
            <p>
              第{{ source.interviews.length - index }}次面试
              <span style="color:red" v-if="item.status == 'FAIL'"
                >（面试未通过）</span
              >
              <span style="color:#42b983" v-if="item.status == 'SUCCESS'"
                >（面试已通过）</span
              >
              <span style="color:#35B5FE" v-if="item.status == 'PROCESS'"
                >（面试进行中）</span
              >
              <span style="color:red" v-if="item.status == 'CANCEL'"
                >（面试已取消）</span
              >
            </p>
          </a-col>
          <a-col>
            <h5 style="color:#9e9e9e;">创建时间：{{ item.created_at }}</h5>
          </a-col>
        </a-row>
        <a-row type="flex" justify="start" style="margin-bottom:15px">
          <a-col span="12" style="padding-left:60px">
            <p>面试类型：{{ item.type_text }}</p>
          </a-col>
          <a-col>面试时间：{{ item.time }}</a-col>
          <a-col
            span="24"
            style="padding-left:60px"
            v-if="item.type === 'INTERVIEW'"
          >
            <p>面试地点：{{ item.address }}</p>
          </a-col>
          <a-col span="24" style="padding-left:60px">
            <p>附言：{{ item.remark }}</p>
          </a-col>
          <!-- <a-col span="24" style="padding-left:60px">
            <p>面试反馈：专业知识不过关</p>
          </a-col>-->
        </a-row>
        <a-divider></a-divider>
      </div>
    </template>
    <div v-else style="text-align:center">暂无数据</div>
    <template v-if="source.offer.id">
      <a-row type="flex" justify="space-between" style="margin-bottom:15px">
        <a-col>
          <a-row type="flex" align="middle" :gutter="15">
            <a-col>
              <span style="height:25px;border-left:3px solid #35B5FE;"></span>
            </a-col>
            <a-col>
              <b>offer信息</b>
            </a-col>
          </a-row>
        </a-col>
        <a-col>
          <h5 style="color:#9e9e9e;">
            创建时间：{{ source.offer.created_at }}
          </h5>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start">
        <a-col span="12" style="padding-left:20px">
          <p>入职者姓名：{{ source.resume_name }}</p>
        </a-col>
        <a-col>
          <p>到岗日期：{{ source.offer.on_board_time }}</p>
        </a-col>
        <a-col span="12" style="padding-left:20px">
          <p>入职岗位：{{ source.job_name }}</p>
        </a-col>
        <a-col>
          <p>
            试用期：{{ $store.state.config.probation[source.offer.probation] }}
          </p>
        </a-col>
        <a-col span="12" style="padding-left:20px">
          <p>年薪：{{ source.offer.salary }}万</p>
        </a-col>
        <a-col span="24" style="padding-left:20px">
          <p>附言：{{ source.offer.remark }}</p>
        </a-col>
      </a-row>
    </template>
  </div>
</template>

<script>
export default {
  name: "Interview",
  props: {
    source: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>
